//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import ClientId from '@models/ClientId';
import DateString from '@models/DateString';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import InstagramHashtag from '@models/InstagramHashtag';
import InstagramUsername from '@models/InstagramUsername';

/**
 * @deprecated  CampaignType is legacy for our old Sampling integration.
 * We should use {@link CampaignSource} instead
 */
export enum CampaignType {
  INFLUENSTER = 'Influenster',
}

export enum CampaignsMediaSort {
  COMMENTS = 'comments',
  ENGAGEMENT = 'engagement',
  LIKES = 'likes',
  TIME = 'time',
  VISUAL_SCORE = 'visualScore',
}

export interface ICampaignMediaStats {
  totalLikes: number;
  avgLikes: number;
  totalComments: number;
  avgComments: number;
}

export interface ICampaign {
  campaignId: string;
  clientId: ClientId;
  externalCampaignId?: string;
  campaignName: string;
  campaignType: CampaignType;
  start: Date;
  end: Date;
  clientHandle: InstagramUsername;
  usernames: InstagramUsername[];
  hashtags: InstagramHashtag[];
}

export interface ICampaignSearchRequestBody {
  searchedHashtags: InstagramHashtag[];
  searchedUsernames: InstagramUsername[];
}

export interface IGetClientCampaignsRequest {
  limit?: number;
  offset?: number;
}

export interface IGetClientCampaignsResponse {
  data: IClientCampaignsResponse;
}

export interface IClientCampaignsResponse {
  campaigns: ICampaign[];
  offset?: number;
}

export interface IGetCampaignResponse {
  data?: ICampaign;
}

export interface IGetCampaignMediaRequest {
  startDate: DateString;
  endDate: DateString;
  orderBy?: CampaignsMediaSort;
  limit?: number;
  offset?: number;
}

export interface IGetCampaignMediaResponse {
  data: ICampaignMediaResponse;
}

export interface ICampaignMediaResponse {
  media: IMlsMediaItem[];
  stats: ICampaignMediaStats;
  offset: number;
  totalCount: number;
}

export interface IGetCampaignAutocompleteRequest {
  startDate: DateString;
  endDate: DateString;
  searchTerm?: string;
}

export interface IGetCampaignAutocompleteResponse {
  data: ICampaignAutocompleteResponse;
}

interface IAutoCompleteResult {
  source: string;
  count: number;
}
export interface ICampaignAutocompleteResponse {
  hashtags: IAutoCompleteResult[];
  labels: IAutoCompleteResult[];
  usernames: IAutoCompleteResult[];
}

export interface IGetCampaignExportRequest {
  startDate: DateString;
  endDate: DateString;
  orderBy?: CampaignsMediaSort;
}
